import {FETCH_ERROR, FETCH_START, FETCH_SUCCESS, HIDE_MESSAGE, SHOW_MESSAGE, ON_PATCH_RESPONSE, ON_PUT_RESPONSE} from '../constants/ActionTypes'

const INIT_STATE = {
  error: "",
  loading: false,
  message: '',
  response: '',
  showAlert: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_START: {
      return { ...state, error: '', message: '', showAlert: false, loading: true };
    }
    case FETCH_SUCCESS: {
      return { ...state, error: '', message: '', loading: false };
    }
    case SHOW_MESSAGE: {
      return { ...state, error: '', message: action.payload, loading: false };
    }
    case FETCH_ERROR: {
      return { ...state, loading: false, error: action.payload, message: '' };
    }
    case HIDE_MESSAGE: {
      return { ...state, loading: false, error: '', message: '' };
    }
    case ON_PATCH_RESPONSE: {
      return { ...state, loading: false, showAlert: true, response: action.payload };
    }

    case ON_PUT_RESPONSE: {
      return { ...state, loading: false, showAlert: true, response: action.payload };
    }
    
    default:
      return state;
  }
}
